export default "__VITE_ASSET__v8zojttt__"